import { fromJS, List, Map, Record } from "immutable";
import { fromJSON as dropdownFromJSON } from "common/components/Dropdown/Dropdown";
import { getPrettyName } from "common/helpers/Pretty";
import { titleCaseString } from "common/helpers/String";
import { Nullable } from "common/types";

export const contractLanguageFromJSON = (json: Partial<IContractLanguageData>): ContractLanguageRecord => {
  const record: IContractLanguageRecord = { ...(json as any) };
  record.format_options = fromJS(
    json.format_options || {
      size: 10,
      align: "center",
    },
  ) as Map<keyof IContractFormatOptions, IContractFormatOptions[keyof IContractFormatOptions]>;

  return new ContractLanguageRecord(record);
};

export type AlignmentType = "left" | "center" | "right";
export const alignmentTypes = List<AlignmentType>(["left", "center", "right"]);

export type LocationType = "header" | "footer";
export const locationTypes = List<LocationType>(["header", "footer"]);

export type DisplayType = "estimate" | "contract" | "both" | "do_not_display";
export const displayTypes = List<DisplayType>(["estimate", "contract", "both", "do_not_display"]);

export interface IContractFormatOptions {
  size: number;
  align: AlignmentType;
}

export const alignmentTypesDropdown = alignmentTypes.map((alignment) =>
  dropdownFromJSON({
    id: alignment,
    name: getPrettyName(alignment),
  }),
);

export const locationTypesDropdown = locationTypes.map((location) =>
  dropdownFromJSON({
    id: location,
    name: getPrettyName(location),
  }),
);

export const displayTypesDropdown = displayTypes.map((display) =>
  dropdownFromJSON({
    id: display,
    name: titleCaseString(display),
  }),
);

export interface IContractLanguageData {
  id?: number;
  display?: DisplayType;
  format_options: IContractFormatOptions;
  is_active?: boolean;
  language?: string;
  location: LocationType;
  sort_order: Nullable<number>;
  _destroy?: boolean;
}

export interface IContractLanguageRecord {
  id: number;
  display?: DisplayType;
  format_options: Map<keyof IContractFormatOptions, IContractFormatOptions[keyof IContractFormatOptions]>;
  is_active?: boolean;
  language?: string;
  location: LocationType;
  sort_order: Nullable<number>;
  _destroy?: boolean;
}

export const defaultContractLanguageProps = {
  id: 0,
  display: "both" as DisplayType,
  format_options: Map({}),
  is_active: true,
  language: "",
  location: "footer" as LocationType,
  sort_order: null,
  _destroy: false,
};

export class ContractLanguageRecord
  extends Record<IContractLanguageRecord>(defaultContractLanguageProps)
  implements IContractLanguageRecord {}
